import type { TTemperatureRecommendation } from '@/entities/visit/model'
import { Badge } from '@chakra-ui/react'

interface Props {
  temperature_c?: number
  temperature_recommendation?: TTemperatureRecommendation
}

const styles: Record<
  TTemperatureRecommendation,
  { bg: string; color: string }
> = {
  NORMAL: { bg: 'badge.red.20', color: 'badge.red.100' },
  HIGH: { bg: 'badge.orange.20', color: 'badge.orange.100' },
  LOW: { bg: 'badge.orange.20', color: 'badge.orange.100' },
}

export const TemperatureBadge = ({
  temperature_c,
  temperature_recommendation,
}: Props) => {
  const defaultStyle = { bg: 'badge.blue.20', color: 'badge.blue.100' }
  const badgeStyle =
    (temperature_recommendation && styles[temperature_recommendation]) ||
    defaultStyle

  return (
    <>
      {temperature_c ? (
        <Badge {...badgeStyle}> {temperature_c} °C</Badge>
      ) : (
        <>-</>
      )}
    </>
  )
}
